"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var datalake_exports = {};
__export(datalake_exports, {
  DatalakeStorage: () => DatalakeStorage
});
module.exports = __toCommonJS(datalake_exports);
var import_core = require("@hcengineering/core");
var import_upload = require("../upload");
const getPathname = /* @__PURE__ */ __name((url) => {
  const base = window?.location?.href !== void 0 ? window.location.href : "http://localhost";
  return new URL(url, base).pathname;
}, "getPathname");
class DatalakeStorage {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }
  static {
    __name(this, "DatalakeStorage");
  }
  getFileUrl(workspace, file, filename) {
    const path = filename !== void 0 ? `/blob/${workspace}/${file}/${filename}` : `/blob/${workspace}/${file}`;
    return (0, import_core.concatLink)(this.baseUrl, path);
  }
  getCookiePath(workspace) {
    const url = (0, import_core.concatLink)(this.baseUrl, `/blob/${workspace}`);
    return getPathname(url);
  }
  async getFileMeta(token, workspace, file) {
    const url = (0, import_core.concatLink)(this.baseUrl, `/meta/${encodeURIComponent(workspace)}/${encodeURIComponent(file)}`);
    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      if (response.ok) {
        return await response.json();
      }
    } catch (err) {
    }
    return {};
  }
  async deleteFile(token, workspace, file) {
    const url = this.getFileUrl(workspace, file);
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error("Failed to delete file");
    }
  }
  async uploadFile(token, workspace, uuid, file, options) {
    if (file.size <= 10 * 1024 * 1024) {
      const formData = new FormData();
      formData.append("file", file, uuid);
      await (0, import_upload.uploadXhr)(
        {
          url: (0, import_core.concatLink)(this.baseUrl, `/upload/form-data/${encodeURIComponent(workspace)}`),
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData
        },
        options
      );
    } else {
      const url = (0, import_core.concatLink)(
        this.baseUrl,
        `/upload/multipart/${encodeURIComponent(workspace)}/${encodeURIComponent(uuid)}`
      );
      const headers = { Authorization: `Bearer ${token}` };
      await (0, import_upload.uploadMultipart)({ url, headers, body: file }, options);
    }
  }
}
//# sourceMappingURL=datalake.js.map
